module.exports = __webpack_public_path__ + "img/6-ilpakamanioMAS.009fec26.jpg";